import type { LiveStatusFilter, MetricPeriod, ReferralOwnerType, ReferralSort } from '@manaro/contracts'

export const queryKeys = {
  session: ['session'] as const,
  updates: ['updates'] as const,
  overview: (period: MetricPeriod) => ['metrics', 'overview', period] as const,
  salons: ['salons'] as const,
  salonNotes: ['salon-notes'] as const,
  salonReminders: ['salon-reminders'] as const,
  referrals: ['referrals'] as const,
  referralList: (filters: {
    ownerType: ReferralOwnerType
    search: string
    suspiciousOnly: boolean
    sort: ReferralSort
    page: number
  }) =>
    ['referrals', 'list', filters.ownerType, filters.search, filters.suspiciousOnly, filters.sort, filters.page] as const,
  referral: (code: string) => ['referrals', 'owner', code] as const,
  promoCodes: ['promo-codes'] as const,
  promoCode: (id: number) => ['promo-codes', 'detail', id] as const,
  supportStats: ['support', 'stats'] as const,
  supportConversations: (filters: { query?: string; escalatedOnly?: boolean; offset?: number }) =>
    ['support', 'conversations', filters.query ?? '', filters.escalatedOnly ?? false, filters.offset ?? 0] as const,
  supportConversation: (id: string) => ['support', 'conversation', id] as const,
  liveSummary: ['live-chat', 'summary'] as const,
  liveConversations: (filter: LiveStatusFilter) => ['live-chat', 'conversations', filter] as const,
  liveConversation: (id: string) => ['live-chat', 'conversation', id] as const,
  staff: ['staff'] as const,
  invite: (token: string) => ['invite', token] as const,
}
